import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import API from '../utils/api';

export default function AboutUs() {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({});
  useEffect(() => { API.get('/settings').then(r => setSettings(r.data)).catch(() => {}); }, []);

  const values = [
    { icon: '🐂', title: t('about.value1Title'), desc: t('about.value1Desc') },
    { icon: '🌾', title: t('about.value2Title'), desc: t('about.value2Desc') },
    { icon: '🏥', title: t('about.value3Title'), desc: t('about.value3Desc') },
    { icon: '🙏', title: t('about.value4Title'), desc: t('about.value4Desc') },
  ];

  const whyIndianCow = [
    { icon: '🧬', title: t('about.a2MilkTitle'), desc: t('about.a2MilkDesc') },
    { icon: '🌱', title: t('about.panchagavyaTitle'), desc: t('about.panchagavyaDesc') },
    { icon: '☀️', title: t('about.suryaketuTitle'), desc: t('about.suryaketuDesc') },
    { icon: '🌾', title: t('about.organicFarmingTitle'), desc: t('about.organicFarmingDesc') },
    { icon: '🔥', title: t('about.sacredRitualsTitle'), desc: t('about.sacredRitualsDesc') },
    { icon: '🐂', title: t('about.nativeBreedsTitle'), desc: t('about.nativeBreedsDesc') },
  ];

  const trustRows = [
    { label: t('about.trustName'), value: settings.trustName },
    { label: t('about.registrationNumber'), value: settings.trustRegNo },
    { label: t('about.section80GNumber'), value: settings.section80GNo },
    { label: t('about.contactEmail'), value: settings.contactEmail },
    { label: t('about.phone'), value: settings.contactPhone },
    { label: t('about.address'), value: settings.address },
  ].filter(r => r.value);

  return (
    <div>
      <div className="page-header">
        <h1>{t('about.pageTitle')}</h1>
        <p>{t('about.pageSubtitle')}</p>
      </div>

      <section className="section">
        <div className="container">
          <div className="about-grid">
            <div>
              <div style={{ fontSize: '8rem', textAlign: 'center', marginBottom: 20 }}>🐂</div>
              <div style={{ background: '#FFF8F0', borderRadius: 12, padding: 24, textAlign: 'center', border: '1.5px solid #FFE0B2' }}>
                <p style={{ fontFamily: 'Noto Serif Devanagari, serif', fontSize: '1.3rem', color: 'var(--saffron)', fontWeight: 600 }}>
                  गोसेवा परमो धर्मः
                </p>
                <p style={{ color: '#888', fontSize: '0.9rem', marginTop: 6 }}>{t('about.quoteGloss')}</p>
              </div>
            </div>
            <div className="about-text">
              <h2><Trans i18nKey="about.missionTitle" components={{ 1: <span style={{ color: 'var(--saffron)' }} /> }} /></h2>
              <p>
                {settings.aboutText || t('about.defaultAboutText')}
              </p>
              <p>
                {t('about.secondParagraph')}
              </p>
              <div className="values-grid">
                {values.map((v, i) => (
                  <div key={i} className="value-item">
                    <div style={{ fontSize: '1.4rem', marginBottom: 4 }}>{v.icon}</div>
                    <h4>{v.title}</h4>
                    <p>{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Indian Cow */}
      <section className="section" style={{ background: '#FFF8F0' }}>
        <div className="container">
          <h2 className="section-title"><Trans i18nKey="about.whyIndianCowTitle" components={{ 1: <span /> }} /></h2>
          <p className="section-subtitle">{t('about.whyIndianCowSubtitle')}</p>
          <div className="grid-3" style={{ marginTop: 32 }}>
            {whyIndianCow.map((item, i) => (
              <div key={i} style={{ background: '#fff', borderRadius: 12, padding: 24, border: '1px solid #e8e0d8' }}>
                <div style={{ fontSize: '2rem', marginBottom: 8 }}>{item.icon}</div>
                <h4 style={{ fontWeight: 700, marginBottom: 8 }}>{item.title}</h4>
                <p style={{ color: '#777', fontSize: '0.9rem', lineHeight: 1.7 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Info */}
      {trustRows.length > 0 && (
        <section className="section">
          <div className="container" style={{ maxWidth: 700 }}>
            <h2 className="section-title"><Trans i18nKey="about.trustDetailsTitle" components={{ 1: <span /> }} /></h2>
            <div style={{ background: '#fff', borderRadius: 12, padding: 28, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', marginTop: 24 }}>
              {trustRows.map((row, i) => (
                <div key={i} style={{ display: 'flex', gap: 16, padding: '10px 0', borderBottom: i < trustRows.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                  <div style={{ width: 180, fontWeight: 600, color: '#888', fontSize: '0.9rem', flexShrink: 0 }}>{row.label}</div>
                  <div style={{ color: '#1a1a1a', fontSize: '0.9rem' }}>{row.value}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section style={{ background: 'linear-gradient(135deg, var(--saffron), var(--saffron-dark))', padding: '50px 0', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ color: '#fff', fontSize: '1.8rem', fontWeight: 700, marginBottom: 16 }}>{t('about.joinMissionTitle')}</h2>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/donations" className="btn" style={{ background: '#fff', color: 'var(--saffron)', fontWeight: 700 }}>{t('common.donateNow')}</Link>
            <Link to="/adopt-a-cow" className="btn btn-outline" style={{ color: '#fff', borderColor: '#fff' }}>{t('common.adoptACow')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
